// extracted by mini-css-extract-plugin
export default {"marker":"CountryStatMarker_marker__Ixddh","icon":"CountryStatMarker_icon__L2U2X","value":"CountryStatMarker_value__cQl1P"};